<template>
  <!-- H5绑定手机号页面 -->
  <div class="bindTel">
    <!-- 手机号 -->
    <div class="infoBox">
      <div class="text">手机号</div>
      <div class="inputBox tel">
        <input type="text" v-model="tel" placeholder="请输入手机号" />
      </div>
    </div>
		<div class="infoBox">
			<div class="text">图形码</div>
			<div class="inputBox verifyImg">
				<input type="number" v-model="imgCode" placeholder="请输入图形验证码" :contextmenu="false">
				<img v-if="verifyImg" :src="verifyImg" alt="" @click="changeVerifyImg" :title="verifyImgTitle">
			</div>
		</div>
    <!-- 验证码 -->
    <div class="infoBox">
      <div class="text">验证码</div>
      <div class="inputBox code">
        <input type="text" v-model="code" placeholder="请输入验证码" />
        <div class="sendCode" @click="sendCode" v-if="!cutdownIsShow">
          {{ getCodeArgin ? '重发验证码' : '获取验证码' }}
        </div>
        <div class="sendCode cutdown" v-if="cutdownIsShow">
          {{ sendtxt }}
        </div>
      </div>
    </div>
    <!-- 绑定并登录按钮 -->
    <div class="bindBtn" :class="{ canbind: canBind }" @click="toBind">
      绑定并登录
    </div>
    <!-- 协议 -->
    <div class="agreement">
      <div class="icon_agree" @click="changeAgree">
        <img
          src="https://images.zhibo.tv/2022/0110/icon_checked.png"
          alt=""
          v-if="isAgree"
        />
        <img
          src="https://images.zhibo.tv/2022/0110/icon_check.png"
          alt=""
          v-else
        />
      </div>
      <div class="text">
        我已阅读并同意
        <span @click="gotoUserAgreement">《中国体育直播用户协议》</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import { getIPs, getBrowserNameVersion,ipToNumber,generateLetters,replaceCharAtIndex } from '@/config/getSysInfo.js'
import md5 from 'js-md5';
import { Toast } from 'vant'
import Qs from 'qs'
import { ADDRESS } from '@/api/address.js'
export default {
  name: 'bindtel',
  data() {
    return {
      tel: '',
      code: '',
      cutdownIsShow: false,
      sendtxt: '',
      // 倒计时
      time: 60,
      // 控制绑定按钮置灰或可点
      canBind: false,
      isAgree: true,
      getCodeArgin: false,
      // 绑定所需
      thirdCode: '',
      loginType: '',
      clientType: '1',
      from: '',
			
			// 2023年06获取短信验证码优化
			imgCode: '',
			statistics: '',
			source: '33',
			
			verifyImg: '',
			
			reqId_Len_A: '',
			reqId: '',
			reqTime: '',
			ip: '',
			reqCode: '',
			verifyImgTitle: '点击切换'
    }
  },
  computed: {
    // 用户是否可以点击绑定按钮（手机号和验证码是否存在）
    userCanBind() {
      const { tel, code, imgCode } = this
      return { tel, code, imgCode }
    }
  },
  watch: {
    // 用户是否可以点击绑定按钮（手机号和验证码是否存在）
		userCanBind: {
      handler(newval, oldval) {
				const regExp = new RegExp("^1[3456789]\\d{9}$");
				console.log(newval, oldval)
				if (regExp.test(newval.tel) && this.code && this.imgCode.length === 4) {
					this.canBind = true
				} else {
					this.canBind = false
				}
      },
      deep: true
    }
  },
  created() {
    document.title = '绑定手机号'
    this.thirdCode = this.$cookies.get('thirdCode')
    this.loginType = this.$cookies.get('login_type')
    this.from = this.$cookies.get('login_origin')
  },
	mounted() {
		this.getSysInfo()
	},
  methods: {
		changeVerifyImg(){
			const regExp = new RegExp("^1[3456789]\\d{9}$");
			if(!regExp.test(this.tel)) return Toast('请输入正确的手机号')
			if(this.cutdownIsShow) return Toast(`${this.time}s后可切换`)
			
			this.cutdownIsShow = true
			this.time = 6
			this.timer()
			this.getSysInfo()
		},
		async getReqId(res,t){
			const { source, statistics } = this;
			let params = `source=${source}&statistics=${statistics}`
			if(res != 'success'){
				params += `&time=${t}`
			}
			const { data } = await this.$api.getReqId(params)
			const { reqId, code, time, ip } = data.data;
			
			this.verifyImg = ADDRESS.address2 + '/user/verify?reqId=' + reqId + '&statistics=' + this.statistics//图形验证码
			
			this.reqId_Len_A = Number(code.charAt(0)) - 5;//A段长度
			this.reqId = reqId;
			this.reqCode = code;
			this.reqTime = time;
			this.ip = ip;
		},
		getSysInfo(){
			getIPs((ip,res) => {
				const VS = getBrowserNameVersion();
				const platform = 'pc';//平台  pc ios android
				const channel = VS.split(' ')[0];//渠道 360 小米 chrome 
				let version = '2.0';//接口版本号
				let deviceId = ipToNumber(ip);//设备号 ip
				let time = ''
				if(res != 'success'){
					deviceId = Number(ipToNumber(ip)) + Number(this.source) + Number(parseInt(new Date().getTime() / 1000))
					time = parseInt(new Date().getTime() / 1000)
				}
				const model = VS.split(' ')[1] ? VS.split(' ')[1] : '1';//浏览器版本
				const useragent = encodeURI(navigator.userAgent);
				const imei = btoa(useragent);//base64位 系统信息
				let str = platform + '|' + channel + '|' + version + '|' + deviceId + '|' + model + '|' + imei + '|' + 'local' + '|' + '5.5.5' + '|' + 'jhkz7thw7829@0*1'
				str = md5(str)
				str = str.substring(str.length - 8)
				version += `-${str}`;
				this.statistics = platform + '|' + channel + '|' + version + '|' + deviceId + '|' + model + '|' + imei + '|' + 'local' + '|' + '5.5.5'
				this.getReqId(res,time)
			})
		},
		setReqId() {
			const reqId_first_code = (this.reqId.charAt(0)).charCodeAt()
			const phone_last_nine = Number(this.tel.substring(2)) + Number(reqId_first_code);//手机号后九位 + reqId第一位的ascii码
			const remainder_number = phone_last_nine % 26;//除以26取余 0-25
			const remainder_letter = String.fromCharCode(Number(remainder_number) + Number(97));//手机号后9位+reqId第一位的ascii码,%26取余,对应a-z
			const remainder_index = phone_last_nine % 4;//手机号后9位+reqId第一位的ascii码,%4取余
			let str = generateLetters(4)//生成一个随机字母字符
			str = replaceCharAtIndex(str,remainder_index,1,remainder_letter)//替换 字符,开始索引,长度,值
			// console.log('重排后得reqId==========>',replaceCharAtIndex(this.reqId,this.reqId_Len_A,4,str))
			return replaceCharAtIndex(this.reqId,this.reqId_Len_A,4,str)
		},
		sortArray() {
			const { setReqId, tel, imgCode, reqTime, source, ip, statistics } = this;
			let newReqId = setReqId();
			let reqId = md5(newReqId + '$^>*<@' + 'JHKZ7THW7829@0*1');
			reqId = reqId.substring(reqId.length - 6)
			reqId = newReqId + reqId
			//key值按照a-z的顺序拼接
			const params = {code: imgCode, ip: ip, phone: tel, reqId: reqId, source: source, time: reqTime}
			let str = '';
			Object.values(params).forEach(e=>{
				str += `${e}&`
			})
			str = str + 'jhkz7thw7829@0*1'
			str = md5(str)
			str = str.substring(str.length - 8)
			params.sign = str
			params.statistics = statistics
			return params
		},
    // 发送验证码
    async sendCode() {
			if(this.cutdownIsShow) return
			const regExp = new RegExp("^1[3456789]\\d{9}$");
			if(regExp.test(this.tel)){
				if(this.imgCode.length === 4){
					const params = this.sortArray()
					const res = await this.$api.sendCodefromPC(Qs.stringify(params))
					if (res.data.control.status == 200) {
						this.time = 60
					} else {
						this.imgCode = ''
						this.time = 6
						this.getSysInfo()
					}
					this.cutdownIsShow = true
					Toast(res.data.control.message)
					this.timer()
				}else{
					Toast('请输入正确的图形验证码')
				}
			}else{
				Toast('请输入正确的手机号')
			}
    },
    // 验证码的倒计时
    timer() {
      if (this.time > 1) {
        this.time--
        this.sendtxt = this.time + 's后获取'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.cutdownIsShow = false
        this.getCodeArgin = true
      }
    },
    // 点击绑定并登录
    async toBind() {
      if (this.canBind) {
        console.log('点击绑定并登录')
        let params = {
          loginType: this.loginType,
          code: this.thirdCode,
          clientType: this.clientType,
          phone: this.tel,
          number: this.code
        }
        let res = await this.$api.gotoBindtel(Qs.stringify(params))
        console.log(res)
        // bindType 1新用户绑定成功 2手机号已经绑定
        if (res.data.control.status == 200) {
          if (res.data.data.bindType == 1) {
            Toast('绑定成功')
            this.getUserInfo()
            this.$cookies.set('isThirdNew', '-1', '1d')
            this.$cookies.set('thirdCode', '-1', '1d')
            setTimeout(() => {
              window.location.href = this.from
            }, 1000)
          } else if (res.data.data.bindType == 2) {
            localStorage.setItem('userHeadImg', res.data.data.userHeadImg)
            localStorage.setItem('userName', res.data.data.userName)
            localStorage.setItem('newtoken', res.data.data.token)
            localStorage.setItem('userMobile', this.tel)
            this.$router.replace({ path: '/boundTel' })
          }
        } else {
          Toast(res.data.control.message)
        }
      }
    },
    // 获取用户信息
    async getUserInfo() {
      axios.defaults.withCredentials = true
      let res = await this.$api.getUserInfo()
      console.log(res)
      if (res.data.status == 200) {
        console.log('获取用户信息')
        this.$cookies.set('token', res.data.data.userToken)
        this.$cookies.set('roomNum', res.data.data.roomNum)
      }
    },
    // 是否阅读并同意
    changeAgree() {
      this.isAgree = !this.isAgree
      console.log('是否点击同意：', this.isAgree)
    },
    // 跳转用户协议
    gotoUserAgreement() {
      window.open(
        'https://www.zhibo.tv/privacypolicy.html?tdsourcetag=s_pctim_aiomsg'
      )
    }
  }
}
</script>

<style lang="less" scoped>
.bindTel {
  width: 100vw;
  height: 100vh;
  .infoBox {
    .text {
      width: 100%;
      height: 1.25rem;
      box-sizing: border-box;
      padding: 0.5rem 0.5rem 0.3rem 0.5rem;
      display: flex;
      align-items: center;

      font-size: 0.3rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    .inputBox {
      margin: 0 0.3rem;
      height: 1.12rem;
      border-bottom: 0.14vw solid rgba(0, 0, 0, 0.1);
      padding-left: 0.22rem;
      display: flex;
      align-items: center;
      input {
        display: block;
        font-size: 0.32rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
      input::placeholder {
        font-size: 0.32rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #b7b7b7;
      }
      .sendCode {
        width: 1.95rem;
        height: 0.62rem;
        background: #fff2f2;
        border-radius: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;

        font-size: 0.24rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ff4a4a;
      }
      .cutdown {
        background: #f8f9fa;
        color: #333333;
      }
    }
		.verifyImg{
			justify-content: space-between;
			img{
				pointer-events: unset;
			}
		}
    .code {
      justify-content: space-between;
      margin-bottom: 1rem;
    }
  }
  .bindBtn {
    width: 6.5rem;
    height: 0.9rem;
    margin: 0 auto;
    background: #d9d9d9;
    border-radius: 0.45rem;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 0.32rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
  .canbind {
    background: #e9001d;
  }
  .agreement {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.4rem;
    .icon_agree {
      width: 0.26rem;
      height: 0.26rem;
      margin-right: 0.1rem;
      img {
        display: block;
        width: 0.26rem;
        height: 0.26rem;
      }
    }
    .text {
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      span {
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
</style>
